import request from '../utils/request'
// 获取图片二维码 参数 : 手机号 
export function getImgCodeApi(data) {
    return request({
        url: 'api/sys/randomImage/' + data.phone,
        method: 'get'
    })
}
// 获取验证码  参数 : 手机号 和 图形二维码
export function getCodeApi(data) {
    return request({
        url: 'api/sys/sendSmsCaptcha',
        method: 'post',
        data
    })
}
// 登录接口
export function loginApi(data) {
    return request({
        url: 'api/sys/phoneLogin',
        method: 'post',
        data
    })
}
// 用户信息更新接口
export function updateUserInfoApi(data) {
    return request({
        url: 'api/sys/user/updateUserInfo',
        method: 'post',
        data
    })
}
// 上传文件接口
export function uploadFileApi(data) {
    return request({
        url: 'api/sys/common/upload',
        method: 'post',
        data
    })
}
// 查询产品接口
export function queryProductApi(data) {
    return request({
        url: 'api/product/serProductResource/queryByName?productName=' + data.productName,
        method: 'get'
    })
}
// 下载产品接口
export function downloadProductApi(data) {
    return request({
        url: 'api/sys/common/download2/' + data.productName,
        method: 'get'
    })
}
// 获取讲师接口
export function getTeacherListApi() {
    return request({
        url: 'api/teacher/serTeacher/list',
        method: 'get'
    })
}
// 获取企业配置
export function getCompanyConfigApi() {
    return request({
        url: 'api/conpany/conpanyInfo/list',
        method: 'get',
    })
}
// 获取轮播图配置
export function getBannerConfigApi() {
    return request({
        url: 'api/content/serSwiper/listGroupByType',
        method: 'get',
    })
}